import { Component, Input, OnInit } from '@angular/core';
import { CustomerReviewStatusModel } from '../../models/master-list/customer-review-status.model';
import { DirectionModel } from "../../models/master-list/direction.model";
import { ShipmentMasterService } from '../../services/shipment-master.service';

@Component({
    selector: 'app-shipment-list-detail',
    templateUrl: './shipment-list-detail.component.html',
    styleUrls: ['./shipment-list-detail.component.scss'],
    standalone: false
})
export class ShipmentListDetailComponent implements OnInit {

  @Input() shipments: any;
  @Input() searchShipment: string;
  @Input() isCustomerReviewForm = false;
  @Input() directions: DirectionModel[];
  @Input() scrollClass: string;

  customerReviewStatuses: CustomerReviewStatusModel[];

  constructor(private readonly masterService: ShipmentMasterService) { }

  ngOnInit() {
    this.masterService.getCustomerReviewStatuses().subscribe((list) => {
      this.customerReviewStatuses = list;
    }
    );
  }

  getCustomerReviewStatus(crStatusId: number): string {
    return this.customerReviewStatuses.find(cr => cr.id === crStatusId)?.customerReviewStatusDescription;
  }

}
